import script from "./TradePassportGalleryAttachments.vue?vue&type=script&setup=true&lang=js"
export * from "./TradePassportGalleryAttachments.vue?vue&type=script&setup=true&lang=js"

import "./TradePassportGalleryAttachments.vue?vue&type=style&index=0&id=57c1aaac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57c1aaac"]])

export default __exports__